// Auto-generated API client from OpenAPI specification
// Generated at: 2026-09-04T17:25:36.875Z

import {ApiRequestConfig, apiClient} from './client';
import * as Types from './types/api.types';

/**
 * Get Invoices
 *
 */
export async function getApiInvoices(
  params?: {
    /** Fetch a single invoice by its composite id ("{inv_number}#{location}#{groupDb}"). Takes precedence over the filter parameters. */
    id?: string;
    /** Filter invoices by status */
    status?:
      | 'pending'
      | 'processing'
      | 'completed'
      | 'failed'
      | 'skipped'
      | 'canceled'
      | 'retry'
      | 'missing_data'
      | 'transfer_failed'
      | 'ims_update_failed'
      | 'previously_processed';
    /** Filter invoices by provider name */
    provider?: string;
    /** Filter invoices by location code */
    location?: string;
    /** Filter invoices created on or after this date (YYYY-MM-DD format) */
    createdFrom?: string;
    /** Filter invoices created on or before this date (YYYY-MM-DD format) */
    createdTo?: string;
    /** Maximum number of invoices to return (1-100) as numeric string */
    limit?: string;
    /** Base64 encoded pagination key for retrieving next page of results */
    exclusiveStartKey?: string;
  },
  config?: ApiRequestConfig
): Promise<Types.GetInvoicesResponse> {
  return apiClient.get('/api/invoices', {params, ...config});
}

/**
 * Update Invoice
 *
 */
export async function putApiInvoices(
  body: Types.InvoiceDocument,
  params?: Record<string, never>,
  config?: ApiRequestConfig
): Promise<Types.UpdateInvoiceResponse> {
  return apiClient.put('/api/invoices', body, {params, ...config});
}

/**
 * Get Credits
 *
 */
export async function getApiCredits(
  params?: {
    /** Fetch a single credit by its composite id ("{cre_number}#{location}#{groupDb}"). Takes precedence over the filter parameters. */
    id?: string;
    /** Filter credits by status */
    status?:
      | 'pending'
      | 'processing'
      | 'completed'
      | 'failed'
      | 'skipped'
      | 'canceled'
      | 'retry'
      | 'missing_data'
      | 'transfer_failed'
      | 'ims_update_failed'
      | 'previously_processed';
    /** Filter credits by provider name */
    provider?: string;
    /** Filter credits by location code */
    location?: string;
    /** Filter credits created on or after this date (YYYY-MM-DD format) */
    createdFrom?: string;
    /** Filter credits created on or before this date (YYYY-MM-DD format) */
    createdTo?: string;
    /** Maximum number of credits to return (1-100) as numeric string */
    limit?: string;
    /** Base64 encoded pagination key for retrieving next page of results */
    exclusiveStartKey?: string;
  },
  config?: ApiRequestConfig
): Promise<Types.GetCreditsResponse> {
  return apiClient.get('/api/credits', {params, ...config});
}

/**
 * Update Credit
 *
 */
export async function putApiCredits(
  body: Types.CreditDocument,
  params?: Record<string, never>,
  config?: ApiRequestConfig
): Promise<Types.UpdateCreditResponse> {
  return apiClient.put('/api/credits', body, {params, ...config});
}

/**
 * Resend Invoice Tungsten
 *
 */
export async function postApiInvoicesResend(
  body: Types.ResendInvoiceRequest,
  params?: Record<string, never>,
  config?: ApiRequestConfig
): Promise<Types.ResendInvoiceTungstenResponse> {
  return apiClient.post('/api/invoices/resend', body, {params, ...config});
}

/**
 * Resend Credit Tungsten
 *
 */
export async function postApiCreditsResend(
  body: Types.ResendCreditRequest,
  params?: Record<string, never>,
  config?: ApiRequestConfig
): Promise<Types.ResendCreditTungstenResponse> {
  return apiClient.post('/api/credits/resend', body, {params, ...config});
}

/**
 * Resend Transmission
 *
 */
export async function postApiTransmissionsResend(
  body: Types.ResendTransmissionRequest,
  params?: Record<string, never>,
  config?: ApiRequestConfig
): Promise<Types.ResendTransmissionResponse> {
  return apiClient.post('/api/transmissions/resend', body, {params, ...config});
}

/**
 * Get Pos Report Logs
 *
 */
export async function getApiPosReportLogs(
  params?: {
    /** Fetch a single POS report log row by its id. Takes precedence over the filter parameters. */
    id?: string;
    /** The POS integration whose transmission history to read. Required unless fetching by id. */
    integration?: 'siemens-pos' | 'square-d-pos';
    /** Only rows written (transmitted) at or after this ISO timestamp */
    modifiedFrom?: string;
    /** Only rows written (transmitted) at or before this ISO timestamp */
    modifiedTo?: string;
    /** Filter by normalised transmission outcome */
    outcome?: 'sent' | 'failed' | 'pending';
    /** Maximum number of rows to return (1-100) as numeric string */
    limit?: string;
    /** Base64 encoded pagination key for retrieving next page of results */
    exclusiveStartKey?: string;
  },
  config?: ApiRequestConfig
): Promise<Types.GetPosReportLogsResponse> {
  return apiClient.get('/api/pos-report-logs', {params, ...config});
}

/**
 * Get Pos Report Log Download
 *
 */
export async function getApiPosReportLogsDownloads(
  params?: {
    /** The id of the POS report log row whose archived payload to download */
    id: string;
  },
  config?: ApiRequestConfig
): Promise<Types.GetPosReportLogDownloadResponse> {
  return apiClient.get('/api/pos-report-logs/downloads', {params, ...config});
}

/**
 * Get Inventory Report Logs
 *
 */
export async function getApiInventoryReportLogs(
  params?: {
    /** Fetch a single inventory report log row by its id. Takes precedence over the filter parameters. */
    id?: string;
    /** The inventory integration whose transmission history to read. Required unless fetching by id. */
    integration?: 'siemens-inventory' | 'square-d-inventory';
    /** Only rows written (transmitted) at or after this ISO timestamp */
    modifiedFrom?: string;
    /** Only rows written (transmitted) at or before this ISO timestamp */
    modifiedTo?: string;
    /** Filter by normalised transmission outcome */
    outcome?: 'sent' | 'failed' | 'pending';
    /** Maximum number of rows to return (1-100) as numeric string */
    limit?: string;
    /** Base64 encoded pagination key for retrieving next page of results */
    exclusiveStartKey?: string;
  },
  config?: ApiRequestConfig
): Promise<Types.GetInventoryReportLogsResponse> {
  return apiClient.get('/api/inventory-report-logs', {params, ...config});
}

/**
 * Get Inventory Report Log Download
 *
 */
export async function getApiInventoryReportLogsDownloads(
  params?: {
    /** The id of the inventory report log row whose archived payload to download */
    id: string;
  },
  config?: ApiRequestConfig
): Promise<Types.GetInventoryReportLogDownloadResponse> {
  return apiClient.get('/api/inventory-report-logs/downloads', {
    params,
    ...config,
  });
}
